import React from 'react';
import { Section } from './Section';
import { AlertTriangle, Clock } from 'lucide-react';
import { motion } from 'framer-motion';
export function Problem() {
  return <Section id="problem" className="bg-zinc-50 border-y border-zinc-200" data-id="element-201">
      <div className="mb-16" data-id="element-202">
        <span className="text-peoplecall tracking-wider text-sm font-semibold mb-4 block" data-id="element-203">
          Why it matters
        </span>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold max-w-3xl leading-tight text-zinc-900" data-id="element-204">
          Incidents happen in seconds.
          <br data-id="element-205" />
          Human response takes minutes.
        </h2>
      </div>

      <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-206">
        <div className="space-y-6 text-lg text-zinc-600 leading-relaxed" data-id="element-207">
          <p data-id="element-208">
            Banks, stores, hospitals — anywhere the public enters, risk enters
            too. Traditional security cameras show you what happened.{' '}
            <strong className="text-zinc-900" data-id="element-209">
              Peoplecall Pod acts before it escalates.
            </strong>
          </p>
          <p data-id="element-210">
            Our AI-powered acoustic detection system is always listening, never
            tired, and never distracted. It identifies dangerous situations the
            moment they start — not after.
          </p>

          <div className="grid grid-cols-2 gap-6 pt-6 border-t border-zinc-200 mt-8" data-id="element-211">
            <div data-id="element-212">
              <div className="flex items-center gap-2 text-zinc-500 mb-2" data-id="element-213">
                <Clock className="w-5 h-5" data-id="element-214" />
                <span className="font-semibold tracking-wide text-sm" data-id="element-215">
                  Traditional
                </span>
              </div>
              <p className="text-zinc-900 font-medium" data-id="element-216">
                Reactive. Relies on human observation.
              </p>
            </div>
            <div data-id="element-217">
              <div className="flex items-center gap-2 text-peoplecall mb-2" data-id="element-218">
                <AlertTriangle className="w-5 h-5" data-id="element-219" />
                <span className="font-semibold tracking-wide text-sm" data-id="element-220">
                  Peoplecall Pod
                </span>
              </div>
              <p className="text-zinc-900 font-medium" data-id="element-221">
                Proactive. Instant autonomous alerts.
              </p>
            </div>
          </div>
        </div>

        <div className="relative" data-id="element-222">
          <img src="https://cdn.magicpatterns.com/uploads/kiEmXfL7CrTqBp81A8ZryW/mic-details.png" alt="Peoplecall Pod microphone close-up" className="w-full h-auto rounded-2xl border border-zinc-200 shadow-xl" data-id="element-223" />

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5,
          duration: 0.5
        }} className="absolute -bottom-4 left-4 right-4 md:left-auto md:-bottom-6 md:-right-6 bg-white border border-peoplecall/30 p-3 rounded-xl shadow-[0_10px_30px_rgba(229,64,0,0.15)] max-w-[260px]" data-id="element-224">
            <div className="flex items-start gap-2.5" data-id="element-225">
              <div className="bg-peoplecall/10 p-1.5 rounded-full mt-0.5 flex-shrink-0" data-id="element-226">
                <AlertTriangle className="w-4 h-4 text-peoplecall" data-id="element-227" />
              </div>
              <div className="min-w-0 flex-1" data-id="element-228">
                <div className="text-peoplecall font-bold text-xs tracking-wide mb-0.5" data-id="element-229">
                  Threat detected
                </div>
                <div className="text-zinc-900 font-medium text-sm mb-0.5 truncate" data-id="element-230">
                  Aggressive Altercation
                </div>
                <div className="text-zinc-500 text-[10px] font-mono" data-id="element-231">
                  Main Lobby • 14:02:45
                </div>
                <div className="mt-2 h-0.5 w-full bg-zinc-100 rounded-full overflow-hidden" data-id="element-232">
                  <motion.div className="h-full bg-peoplecall" initial={{
                  width: '0%'
                }} animate={{
                  width: '100%'
                }} transition={{
                  duration: 2,
                  repeat: Infinity
                }} data-id="element-233" />
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </Section>;
}